import classNames from 'classnames';
export function getClassNames(className) {
  for (var _len = arguments.length, props = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    props[_key - 1] = arguments[_key];
  }

  return classNames.apply(void 0, ["aqe-".concat(className)].concat(props));
}